import React, { useEffect } from "react";
import { draw } from "./draw";

export const StoredValueChart = ({ data, width, height, config, lRef }) => {
  height = height - 4;

  useEffect(() => {
    draw(lRef.current, data, config);
  }, [data, width, height, config, lRef]);

  return <svg ref={lRef} width={width} height={height}></svg>;
};
